module.exports = __webpack_public_path__ + "fonts/tt_sushkof_demi_bold.1ab79b7.ttf";